"use strict";

exports.__esModule = true;
exports.ActionSelector = ActionSelector;
var _react = _interopRequireDefault(require("react"));
var _Selector = require("../Selector");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function getKey(input) {
  return input.id;
}
function renderItemText(input) {
  return input.label;
}
function itemPredicate(query, item) {
  var q = query.toLowerCase();
  return item.label.toLowerCase().indexOf(q) !== -1;
}
function ActionSelector(props) {
  return /*#__PURE__*/_react["default"].createElement(_Core.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
      itemPredicate: itemPredicate,
      placeholder: props.multiple ? translate("ActionSelector.placeholder.multiple", "Select Actions") : translate("ActionSelector.placeholder.single", "Select Action"),
      getKey: getKey,
      renderItemText: renderItemText
    }, props));
  });
}